export const USER_CONTACTS_TRACK_USER_IDS = 'USER_CONTACTS_TRACK_USER_IDS';

export const CONTACT_TYPES = {
    GOOGLE: 'google',
};
